<template>
  <a-card :bordered="false">
    <!-- 条件搜索 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item :label="$t('技能管理.技能类型')">
              <a-select v-model="queryParam.skillType" allowClear @change="handleQuery">
                <a-select-option :value="1">{{ $t('技能管理.通用技能') }}</a-select-option>
                <a-select-option :value="2">{{ $t('技能管理.废品技能') }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
              <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮 -->
    <div class="table-operations">
      <a-button type="primary" @click="handleAdd" v-hasPermi="['homeservice:skill:add']">
        <a-icon type="plus" />{{$t('通用.按钮.新增')}}
      </a-button>
    </div>

    <!-- 数据表格 -->
    <a-table
      :loading="loading"
      rowKey="id"
      :columns="columns"
      :data-source="list"
      :pagination="false"
      :bordered="tableBordered"
    >
      <span slot="status" slot-scope="text, record">
        <a-tag :color="record.status === 1 ? 'green' : 'red'">
          {{ record.statusName }}
        </a-tag>
      </span>
      <span slot="operation" slot-scope="text, record">
        <a @click="handleUpdate(record)" v-hasPermi="['homeservice:skill:edit']">
          <a-icon type="edit" />{{$t('通用.按钮.修改')}}
        </a>
        <a-divider type="vertical" />
        <a @click="handleDelete(record)" v-hasPermi="['homeservice:skill:remove']">
          <a-icon type="delete" />{{$t('通用.按钮.删除')}}
        </a>
      </span>
    </a-table>

    <!-- 新增/编辑弹窗 -->
    <create-form ref="createForm" @ok="getList" />
  </a-card>
</template>

<script>
import { listSkill, delSkill } from '@/api/homeworker/skill'
import { tableMixin } from '@/store/table-mixin'
import CreateForm from './modules/CreateForm'

export default {
  name: 'HomeServiceSkill',
  components: { CreateForm },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      loading: false,
      queryParam: {
        skillType: undefined
      },
      columns: [
        { title: this.$t('技能管理.技能名称'), dataIndex: 'skillName' },
        { title: this.$t('技能管理.技能类型'), dataIndex: 'skillTypeName' },
        { title: this.$t('技能管理.排序'), dataIndex: 'sort' },
        { title: this.$t('技能管理.状态'), dataIndex: 'status', scopedSlots: { customRender: 'status' } },
        { title: this.$t('通用.文本.操作'), dataIndex: 'operation', scopedSlots: { customRender: 'operation' } }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      listSkill(this.queryParam.skillType).then(response => {
        this.list = response.data
        this.loading = false
      })
    },
    handleQuery() {
      this.getList()
    },
    resetQuery() {
      this.queryParam = { skillType: undefined }
      this.handleQuery()
    },
    handleAdd() {
      this.$refs.createForm.handleAdd()
    },
    handleUpdate(row) {
      this.$refs.createForm.handleUpdate(row)
    },
    handleDelete(row) {
      const that = this
      this.$confirm({
        title: this.$t('通用.文本.确认删除'),
        content: this.$t('技能管理.确认删除技能', { name: row.skillName }),
        onOk() {
          delSkill({ id: row.id }).then(() => {
            that.$message.success(that.$t('通用.文本.删除成功'))
            that.getList()
          })
        }
      })
    }
  }
}
</script>
